import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import bowser from 'yola-bowser';
import noop from '../utils/noop';
import Icon from '../design-system/components/icon';

function ImageGrid({
  className = null,
  items,
  columns = null,
  activeItemId = '',
  onItemClick = noop,
  iconSize = '100%',
  onError = noop,
  ...otherImageProps
}) {
  const style = {
    gridTemplateColumns: columns
      ? `repeat(${columns}, 1fr)`
      : `repeat(auto-fit, minmax(${iconSize}, 1fr))`,
  };

  const isMobile = bowser.mobile || bowser.tablet;

  return (
    <div className={classnames('ws-image-grid', className)} style={style}>
      {items.map((item) => {
        const isActive = item.id === activeItemId;

        return (
          <div
            className={classnames('ws-image-grid__cell', {
              'ws-image-grid__cell--active': isActive,
              'ws-image-grid__cell--mobile': isMobile,
            })}
            style={{ minWidth: iconSize, minHeight: iconSize }}
            key={item.id}
          >
            {item.src ? (
              <img
                className="ws-image-grid__item"
                src={item.src}
                alt={item.title}
                onClick={() => {
                  onItemClick(item);
                }}
                onError={() => {
                  onError(item);
                }}
                {...otherImageProps}
              />
            ) : (
              <div className="ws-image-grid__broken-image">
                <Icon size={24} strokeWidth={1.3} glyph="broken-image" type="inherit" />
              </div>
            )}

            {isActive && (
              <span className="ws-image-grid__icon">
                <Icon size={12} strokeWidth={3} glyph="check" type="white" />
              </span>
            )}
            {item.isAnimated && (
              <span className="ws-image-grid__animated-icon">
                <Icon size={10} glyph="play" />
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}

ImageGrid.propTypes = {
  className: PropTypes.string,
  iconSize: PropTypes.string,
  columns: PropTypes.number,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      src: PropTypes.string,
      isAnimated: PropTypes.bool,
    })
  ).isRequired,
  activeItemId: PropTypes.string,
  onItemClick: PropTypes.func,
  onError: PropTypes.func,
};

export default ImageGrid;
